module.exports = __webpack_public_path__ + "img/gd-fiori-pc.55ba5d96.png";